import { render } from "./Preview1.vue?vue&type=template&id=dfc68eb6"
const script = {}

import exportComponent from "/home/dylan/projects/bloemplein-cms-demo/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__